export default __webpack_public_path__ + "static/media/sample_1.8984af11.png";